<template>
  <MenuPopup class="min-w-230px">
    <div class="border-b border-border" v-show="spacesList.length > 1">
      <MenuPopupItem v-for="(space,i) in spacesList" :key="i"
                     @click.native="changeSpace(space.id)"
                     :active="space.id === user_info.data.space_id"
                     :mute-inactive="true">
        <template slot="icon">
          <IconWallet/>
        </template>
        <template slot="text">{{ space.title }}</template>
      </MenuPopupItem>
    </div>
    <MenuPopupItem v-show="!!user_info.data.space_id" @click.native="$router.push({name:'settings-space'})">
      <template slot="icon">
        <IconCog/>
      </template>
      <template slot="text">{{ $t('spaceSettings') }}</template>
    </MenuPopupItem>
    <MenuPopupItem @click.native="$router.push({name:'profile-settings'})">
      <template slot="icon">
        <IconProfile/>
      </template>
      <template slot="text">{{ $t('profileSettings') }}</template>
    </MenuPopupItem>
    <MenuPopupItem @click.native="$router.push({name:'ticket-system'})">
      <template slot="icon">
        <IconCommentOutline/>
      </template>
      <template slot="text">{{ $t('support') }}</template>
    </MenuPopupItem>
    <MenuPopupItem @click.native="logoutBtn">
      <template slot="icon">
        <IconLogout/>
      </template>
      <template slot="text" class="font-medium">{{ $t('logout') }}</template>
    </MenuPopupItem>
  </MenuPopup>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import IconCog from "@/components/icons/IconCog";
import IconProfile from "@/components/icons/IconProfile";
import IconLogout from "@/components/icons/IconLogout";
import IconWallet from "@/components/icons/IconWallet";
import IconRoundTick from "@/components/icons/IconRoundTick";
import MenuPopup from "@/components/common/MenuPopup/MenuPopup";
import MenuPopupItem from "@/components/common/MenuPopup/MenuPopupItem";
import IconCommentOutline from "@/components/icons/IconCommentOutline";

export default {
  name: "HeaderUserPopup",
  components: {
    IconCommentOutline,
    MenuPopupItem,
    MenuPopup,
    IconRoundTick,
    IconWallet,
    IconLogout,
    IconProfile,
    IconCog
  },
  computed: {
    ...mapState('auth', ['fp']),
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('space', ['spacesList'])
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('cabinet/user', ['setUserPrimarySpaceId']),
    logoutBtn() {
      let fingerprint = this.fp.result;
      this.logout(fingerprint)
    },
    goTo(name) {
      this.$emit('hide');
      this.$router.push({name});
    },
    changeSpace(space_id) {
      this.$emit('hide');
      this.setUserPrimarySpaceId(space_id);
    }
  },
  i18n: {
    messages: {
      en: {
        spaceSettings: 'Settings',
        profileSettings: 'Profile settings',
        support: 'Support',
        logout: 'Log out',
      },
      ru: {
        spaceSettings: 'Настройки',
        profileSettings: 'Профиль',
        support: 'Помощь',
        logout: 'Выход',

      }
    }
  },
  beforeRouteLeave() {
    this.$emit('hide');
  }
}
</script>
